
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, useParams } from 'react-router-dom';
import useToggleSidebar from "../../../components/togglesidebar";
import axios from 'axios';
import API_URL from "../../../config/config";

import Sidebar from '../../sidebar';
import Header from '../../Header';
import Footer from '../../footer';

function UserDetails() {
    const { id } = useParams();
    const [userDetails, setUserDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const token = localStorage.getItem("adminToken");
    const { isSidebarOpen, toggleSidebar } = useToggleSidebar();

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                console.log("Fetching user details for ID:", id);
                const response = await axios.get(`${API_URL}/user/show/${id}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                console.log("User details response:", response.data); // Log the full response to debug if needed
                setUserDetails(response.data.data);
            } catch (err) {
                console.error("Error fetching user details:", err);
                setError(err.response?.data?.message || "Failed to fetch user details");
            } finally {
                setLoading(false);
            }
        };
        fetchUserDetails();
    }, [id, token]);


    if (loading) return (
        <div className="content-wrapper" style={{ marginLeft: "70px", transition: "margin-left .3s" }}>
            <div className="text-center py-5">Loading user details...</div>
        </div>
    );
    if (error) return (
        <div className="content-wrapper" style={{ marginLeft: "70px", transition: "margin-left .3s" }}>
            <div className="alert alert-danger text-center mx-3 my-3">Error: {error}</div>
        </div>
    );

    if (!userDetails) {
        return (
            <div className="content-wrapper" style={{ marginLeft: "70px", transition: "margin-left .3s" }}>
                <div className="text-center py-5">No user data available.</div>
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <title>Admin | View User Details</title>
            </Helmet>
            <Sidebar isSidebarOpen={isSidebarOpen} />
            <div className={`content-overlay ${isSidebarOpen && window.innerWidth <= 992 ? "blurred" : ""}`} onClick={() => isSidebarOpen && window.innerWidth <= 992 && toggleSidebar()}>
                <div className="content-wrapper" style={{ marginLeft: isSidebarOpen ? "250px" : "70px", transition: "margin-left .3s" }}>
                    <Header toggleSidebar={toggleSidebar} />
                    <section className='content'>
                        <div className="breadcrumb-main-bx">
                            <div className="breadcrumb-bx">
                                <Link className="breadcrumb-link" to="/admin/dashboard">Dashboard</Link>
                                <div className="breadcrumb-link breadcrumb-disabled">/</div>
                                <Link className="breadcrumb-link" to="/admin/user">User</Link>
                                <div className="breadcrumb-link breadcrumb-disabled">/</div>
                                <div className="breadcrumb-link breadcrumb-active">Details</div>
                            </div>
                        </div>
                        <div className='container-fluid'>
                            {/* -----------Details-------------------- */}
                            <div className='row mt-3'>
                                <div className='col-md-12'>
                                    <div className='card'>
                                        <div className="card-header d-flex justify-content-between align-items-center">
                                            <div>Details</div>
                                        </div>
                                        <div className='card-body'>
                                            <div id='challenge-requests-table_wrapper' className='dataTables_wrapper no-footer'>
                                                <div className='table-responsive'>
                                                    <table className="table table-bordered dataTable no-footer overflow-x-auto" id="challenge-requests-table">
                                                        <tbody>
                                                            <tr>
                                                                <td><strong>User Name:</strong></td>
                                                                <td>{userDetails.name || "-"}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>E-mail Id:</strong></td>
                                                                <td>{userDetails.email || "-"}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>City:</strong></td>
                                                                <td>{userDetails.city || "-"}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>Country:</strong></td>
                                                                {/* This line was changed */}
                                                                <td>{userDetails.country_name ? userDetails.country_name : "-"}</td>
                                                            </tr>

                                                            <tr>
                                                                <td><strong>Source:</strong></td>
                                                                <td>{userDetails.source || "-"}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>Phone:</strong></td>
                                                                <td>{userDetails.phone_number || "-"}</td>
                                                            </tr>
                                                            {/* <tr>
                                                                <td><strong>Status:</strong></td>
                                                                <td>{userDetails.status || "-"}</td>
                                                            </tr> */}
                                                            {/* <tr>
                                                                <td><strong>Email Verified:</strong></td>
                                                                <td>{userDetails.email_verified_at ? "Verified" : "Not Verified"}</td>
                                                            </tr> */}
                                                            {/* <tr>
                                                                <td><strong>Is Affiliate:</strong></td>
                                                                <td>{userDetails.is_affiliate ? "Yes" : "No"}</td>
                                                            </tr> */}
                                                            {/* <tr>
                                                                <td><strong>Created On:</strong></td>
                                                                <td>{userDetails.created_at_formattad || (userDetails.created_at ? new Date(userDetails.created_at).toLocaleDateString() : "-")}</td>
                                                            </tr> */}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* ---------------------------------------------------------------------------------- */}
                            </div>
                        </div>
                    </section>
                    <div style={{ marginLeft: isSidebarOpen ? "0" : "0", }}>
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserDetails;
